module.exports = __webpack_public_path__ + "img/002-venus.538a0989.svg";